import React from "react";
import { colors } from "../shared/constants";
import { LuChevronRight } from "react-icons/lu";

export function Breadcrumbs({ siteName, path, onNavigateHome, onNavigate }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", color: colors.slate, flexWrap: "wrap" }}>
      <span
        style={{ cursor: "pointer", color: colors.blue, fontWeight: "500" }}
        onClick={onNavigateHome}
      >
        Records
      </span>
      <LuChevronRight size={13} />
      <span
        style={{ cursor: path.length ? "pointer" : "default", color: path.length ? colors.blue : colors.text, fontWeight: path.length ? "500" : "700" }}
        onClick={() => path.length && onNavigate(-1)}
      >
        {siteName}
      </span>
      {path.map((crumb, i) => (
        <React.Fragment key={crumb.id}>
          <LuChevronRight size={13} />
          <span
            style={{
              cursor: i < path.length - 1 ? "pointer" : "default",
              color: i < path.length - 1 ? colors.blue : colors.text,
              fontWeight: i < path.length - 1 ? "500" : "700",
            }}
            onClick={() => i < path.length - 1 && onNavigate(i)}
          >
            {crumb.name}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
